var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MonacoDiff',{staticClass:"pa-4",style:({
        // the changes dialog is 80vh and i dont have time to make this flex
        height: '70vh',
    }),attrs:{"language":"JSON","before":_vm.originalEntityDataString,"after":_vm.editedEntityDataString}})
}
var staticRenderFns = []

export { render, staticRenderFns }